<div class="feedback-container">
    <div (click)="feedbackForMessage('thumbs up')" tabindex="0" (keydown.enter)="feedbackForMessage('thumbs up')">
        @if (message.feedback === 'None' || message.feedback === 'thumbs down'){
        <mat-icon fontIcon="thumb_up_off_alt" class="feedback-thumbsup">
        </mat-icon>
        } @else {
        <mat-icon fontIcon="thumb_up_alt" class="feedback-thumbsup">
        </mat-icon>
        }
    </div>
    <div (click)="feedbackForMessage('thumbs down')" tabindex="0" (keydown.enter)="feedbackForMessage('thumbs down')">
        @if (message.feedback === 'None' || message.feedback === 'thumbs up'){
        <mat-icon fontIcon="thumb_down_off_alt" class="feedback-thumbsdown">
        </mat-icon>
        } @else {
        <mat-icon fontIcon="thumb_down_alt" class="feedback-thumbsup">
        </mat-icon>
        }
    </div>
</div>
<div *ngIf="message.additionalFeedbackFlag">
    <app-feedback-detail [feedbackReasonText]="feedbackReasonText" (sendCloseEvent)="initializeFeedback($event)"
        [responseId]="message['responseId']" [feedback]="message['feedback']"
        [uniqueConversationId]="uniqueConversationId"></app-feedback-detail>
</div>